import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Link from 'shared/components/Link/Link';
import s from './TabButtons.css';

class TabButtons extends React.Component {
  static propTypes = {
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        tab: PropTypes.string,
        slug: PropTypes.string,
        badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
    ).isRequired,
    pathname: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired,
  };

  render() {
    const { buttons, activeTab, pathname } = this.props;

    return (
      <div className={s.root}>
        {buttons.map(({ title, tab, slug, badge }) =>
          <Link
            to={`/${pathname}/${slug ? `${slug}/` : ''}`}
            className={cx(s.link, { [s.active]: activeTab === tab })}
            key={tab}
          >
            {title}
            {badge !== 0
              ? <span className={s.badge}>
                  {' '} {badge}
                </span>
              : null}
          </Link>,
        )}
      </div>
    );
  }
}

export default withStyles(s)(TabButtons);



// WEBPACK FOOTER //
// ./src/desktop/components/TabButtons/TabButtons.js